import { mergeWith } from 'lodash'

const actionTypes = {
  SetExportData: 'exporter/SET_EXPORT_DATA',
  SetExportSort: 'exporter/SET_EXPORT_SORT',
  SetExportReportData: 'exporter/SET_EXPORT_REPORT_DATA',
}

const initialState = {
  outputs: [], // array of data outputs
  from: null, // pdf, what function to utilize via "STRING_TYPE" ie "DISCOVERY", "REPORTING" etc
  sort: null,
  report: null,
  exportPreparing: false, // true only while an async export dataset is still being assembled
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetExportData:
      // Default exportPreparing back to false on every update so the flag can never leak to another
      // page; only a payload that explicitly sets it true (Discover all-companies) turns it on.
      return { ...state, exportPreparing: false, ...action.payload.exportData }
    case actionTypes.SetExportSort:
      return { ...state, sort: action.payload }
    case actionTypes.SetExportReportData:
      return {
        outputs: [],
        from: action.payload?.type || (action.payload ? state.from : null),
        sort: action.payload ? state.sort : null,
        report: action.payload
          ? mergeWith({}, state.report, action.payload, (objValue, srcValue) =>
              Array.isArray(objValue) ? srcValue : undefined,
            )
          : null,
      }
    default:
      return state
  }
}

export const actions = {
  setExportData: (exportData) => ({
    type: actionTypes.SetExportData,
    payload: { exportData },
  }),
  setExportSort: (payload) => ({
    payload,
    type: actionTypes.SetExportSort,
  }),
  setExportReportData: (payload) => ({
    payload,
    type: actionTypes.SetExportReportData,
  }),
}
